import { useState, useEffect } from "react";
import { getTaskEvents, type TaskEvent } from "../../../api/tasks";

type TaskHistoryProps = {
  taskId: string;
};

export function TaskHistory({ taskId }: TaskHistoryProps) {
  const [events, setEvents] = useState<TaskEvent[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);
    getTaskEvents(taskId, { page_size: 100 })
      .then((data) => {
        if (!mounted) return;
        setEvents(data.items || []);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Failed to load task events:", error);
        setIsLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [taskId]);

  if (isLoading) {
    return <div className="p-4 text-center text-muted-foreground">Chargement...</div>;
  }

  return (
    <div className="space-y-2">
      {events.length === 0 ? (
        <div className="p-4 text-center text-muted-foreground">Aucun événement</div>
      ) : (
        events.map((event) => (
          <div key={event.id} className="p-3 border border-border rounded-lg">
            <div className="flex items-center justify-between">
              <span className="font-medium">{event.event_type}</span>
              <span className="text-xs text-muted-foreground">
                {new Date(event.at).toLocaleString()}
              </span>
            </div>
            {event.actor_user_id && (
              <p className="text-xs text-muted-foreground mt-1">
                Par: {event.actor_user_id.substring(0, 8)}...
              </p>
            )}
            {event.payload && (
              <pre className="text-xs mt-2 p-2 bg-muted rounded">
                {JSON.stringify(event.payload, null, 2)}
              </pre>
            )}
          </div>
        ))
      )}
    </div>
  );
}
